"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdditionalHotelInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var AdditionalHotelInfo = exports.AdditionalHotelInfo = function AdditionalHotelInfo(_ref) {
  var icon = _ref.icon,
    children = _ref.children,
    title = _ref.title,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.root, className)
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.icon,
    dangerouslySetInnerHTML: {
      __html: icon
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.content
  }, title && /*#__PURE__*/_react.default.createElement("strong", null, title), children));
};
AdditionalHotelInfo.propTypes = {
  children: _propTypes.default.node.isRequired,
  title: _propTypes.default.string,
  icon: _propTypes.default.string,
  className: _propTypes.default.string
};